import React, { useState, useEffect, useContext } from 'react';
import { LoginContext } from '../../../Contexts/LoginContext';
import image1 from '../../../images/pngs/signUp1.png';
import image2 from '../../../images/pngs/hero1.png';
import image3 from '../../../images/pngs/hero2.png';
import image4 from '../../../images/pngs/hero3.png';
import image5 from '../../../images/pngs/hero4.png';
import image6 from '../../../images/pngs/signUp5.png';
import image7 from '../../../images/pngs/hero5.png';
import image8 from '../../../images/pngs/hero6.png';
import image9 from '../../../images/pngs/signUp3.png';
import image10 from '../../../images/pngs/hero7.png';
import empanadasImage from '../../../images/svgs/heroBG.svg';
import SearchBar from '../../utils/SearchBar';
import { useNavigate } from 'react-router-dom';
import { CategoryContext } from '../../../Contexts/CategoryContext';
import { showToast } from '../../utils/ShowToast';
import TradeLeadModal from './TradeLeadModal';

const Hero = () => {
    const { isLogin } = useContext(LoginContext);
    const [searchQuery, setSearchQuery] = useState('');
    const [filters, setFilters] = useState({});
    const navigate = useNavigate();
    const { categories } = useContext(CategoryContext);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const slides = [
        {
            heading: 'Celebrate Moments with',
            highlight: 'Signature Cakes',
            subtitle: 'Discover beautifully crafted desserts and celebration favorites made by expert local bakers.',
            image: image1,
        },
        {
            heading: 'Express Feelings with',
            highlight: 'Fresh Blooms',
            subtitle: 'Thoughtfully arranged floral gifts perfect for celebrations, surprises, and special occasions.',
            image: image2,
        },
        {
            heading: 'Indulge in Delightful',
            highlight: 'Sweet Bites',
            subtitle: 'Explore handcrafted bakery treats prepared fresh for everyday cravings and celebrations.',
            image: image3,
        },
        {
            heading: 'Discover Irresistible',
            highlight: 'Bakery Classics',
            subtitle: 'From pastries to desserts, enjoy premium baked creations made with passion.',
            image: image4,
        },
        {
            heading: 'Send Curated',
            highlight: 'Gift Baskets',
            subtitle: 'Custom gift baskets and hampers designed to make every occasion memorable.',
            image: image5,
        },
        {
            heading: 'Enjoy Homemade',
            highlight: 'Dessert Specials',
            subtitle: 'Freshly prepared sweet delights crafted with authentic flavors and care.',
            image: image6,
        },
        {
            heading: 'Make Every Occasion',
            highlight: 'Extra Special',
            subtitle: 'Unique gift boxes and personalized surprises for meaningful celebrations.',
            image: image7,
        },
        {
            heading: 'Create Unforgettable',
            highlight: 'Event Moments',
            subtitle: 'Find decorations, accessories, and essentials to elevate your celebrations.',
            image: image8,
        },
        {
            heading: 'Taste Authentic',
            highlight: 'Global Flavors',
            subtitle: 'Explore savory and specialty foods prepared by trusted local vendors.',
            image: image9,
        },
        {
            heading: 'Book Trusted',
            highlight: 'Expert Services',
            subtitle: 'Professional photographers, decorators, makeup artists and event specialists near you.',
            image: image10,
        },
    ];

    const [currentSlide, setCurrentSlide] = useState(0);
    const [featureImage, setFeatureImage] = useState(slides[0].image);
    const [animateFeatureImage, setAnimateFeatureImage] = useState(false);
    const [textFading, setTextFading] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            setTextFading(true);
            setTimeout(() => {
                setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
                setTextFading(false);
            }, 350);
        }, 4500);
        return () => clearInterval(timer);
    }, [slides.length]);

    useEffect(() => {
        setAnimateFeatureImage(true);
        const animationTimeout = setTimeout(() => {
            setFeatureImage(slides[currentSlide].image);
        }, 300);

        const resetAnimationTimeout = setTimeout(() => {
            setAnimateFeatureImage(false);
        }, 500);

        return () => {
            clearTimeout(animationTimeout);
            clearTimeout(resetAnimationTimeout);
        };
    }, [currentSlide, slides]);

    const handleSearch = (query, filters) => {
        const hasFilters = Object.values(filters).some(val => val && (Array.isArray(val) ? val.length > 0 : true));
        if (!query && !hasFilters) {
            showToast("Search term or filter is required", "warning");
            return;
        }
        const params = new URLSearchParams();
        if (query) params.set('query', query);
        Object.entries(filters).forEach(([key, value]) => {
            if (value) {
                if (Array.isArray(value)) {
                    if (value.length > 0) params.set(key, value.join(','));
                } else {
                    params.set(key, value);
                }
            }
        });
        navigate(`/products-services?${params.toString()}`);
    };

    const renderLoggedInContent = () => (
        <div className="tradeLeadForm">
            <p className="tradeleadFormTitle">Tell us what you are looking for</p>
            <button className="primaryBtn2" onClick={() => setIsModalOpen(true)}>
                Get a Quote
            </button>
        </div>
    );

    const renderLoggedOutContent = () => (
        <button className="primaryBtn2" onClick={() => navigate('/signup')}>
            JOIN NOW
        </button>
    );

    return (
        <section className="heroSectionContainer">
            <section className="mainSection">
                <SearchBar
                    isHome={true}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    enableFilters={true}
                    filters={filters}
                    setFilters={setFilters}
                    onSearch={handleSearch}
                    categories={categories}
                />
                <div className="imageWrapper">
                    <img src={empanadasImage} draggable={false} alt="Background" className="fixedBackground selectDisable" />
                    <img src={featureImage} draggable={false} alt={slides[currentSlide].highlight} className={`featureImage selectDisable ${animateFeatureImage ? 'slideIn' : ''}`} />
                </div>
                <div className="heroContent">
                    <div className={`heroTextBlock ${textFading ? 'heroTextFadeOut' : 'heroTextFadeIn'}`}>
                        <h1>{slides[currentSlide].heading} <span className="highlight">{slides[currentSlide].highlight}</span></h1>
                        <p>{slides[currentSlide].subtitle}</p>
                    </div>
                    {!isLogin && renderLoggedOutContent()}
                    <div className="slider">
                        <div className="sliderTrack" style={{ transform: `translateX(-${currentSlide * (100 / 3)}%)`, transition: 'transform 0.5s ease-in-out' }}>
                            {slides.concat(slides.slice(0, 3)).map((slide, index) => (
                                <div key={index} className="sliderItem" style={{ minWidth: `${100 / 3}%` }}>
                                    <div className="circleWrapper">
                                        <img src={slide.image} draggable={false} alt={slide.highlight} className="sliderImage selectDisable" />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="dottedLine left"></div>
                        <div className="dottedLine right"></div>
                    </div>
                    <div className="paginationDots">
                        {slides.map((_, index) => (
                            <span key={index} className={`dot ${index === currentSlide ? 'active' : ''}`}></span>
                        ))}
                    </div>
                    {isLogin && renderLoggedInContent()}

                </div>
            </section>
            {isModalOpen && <TradeLeadModal onClose={() => setIsModalOpen(false)} />}
        </section>
    );
};

export default Hero;